// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.construction-group[data-v-046272fe] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.construction-group .btns[data-v-046272fe] {
  margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/ConstructionGroup/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;ACAF;ADNA;EAQI,mBAAA;ACCJ","sourcesContent":["\n.construction-group {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 500px;\n  height: 100%;\n  .btns {\n    margin-bottom: 12px;\n  }\n}\n",".construction-group {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 500px;\n  height: 100%;\n}\n.construction-group .btns {\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
